import { forwardRef, useState, type InputHTMLAttributes } from "react";
import styles from "./PasswordInput.module.css";

type PasswordInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & {
  visibilityLabel?: string;
};

function EyeIcon({ visible }: { visible: boolean }) {
  return (
    <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24">
      {visible ? (
        <>
          <path d="m3.5 3.5 17 17" />
          <path d="M10.55 10.65a2.15 2.15 0 0 0 2.8 2.8" />
          <path d="M9.75 5.15A9.9 9.9 0 0 1 12 4.9c5.7 0 9.15 7.1 9.15 7.1a15.6 15.6 0 0 1-2.2 3.2" />
          <path d="M6.35 6.55C4.05 8.35 2.85 12 2.85 12s3.45 7.1 9.15 7.1a9.8 9.8 0 0 0 3.75-.75" />
        </>
      ) : (
        <>
          <path d="M2.85 12S6.3 5.65 12 5.65 21.15 12 21.15 12 17.7 18.35 12 18.35 2.85 12 2.85 12Z" />
          <circle cx="12" cy="12" r="2.45" />
        </>
      )}
    </svg>
  );
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(function PasswordInput(
  { className = "", visibilityLabel = "password", ...inputProps },
  ref,
) {
  const [visible, setVisible] = useState(false);
  const action = visible ? "Hide" : "Show";

  return (
    <span className={styles.field}>
      <input
        {...inputProps}
        className={`${styles.input} ${className}`.trim()}
        ref={ref}
        type={visible ? "text" : "password"}
      />
      <button
        aria-label={`${action} ${visibilityLabel}`}
        aria-pressed={visible}
        className={styles.toggle}
        onClick={() => setVisible((current) => !current)}
        onMouseDown={(event) => event.preventDefault()}
        type="button"
      >
        <EyeIcon visible={visible} />
      </button>
    </span>
  );
});
